import useSimDetails from 'api/sims/useSimDetails';
import useSimStatuses from 'api/sims/useSimStatuses';
import { useCallback, useMemo } from 'react';
import type { DropdownItemEntry, ManageSimItemHook } from '../types';

const useSendMessage: ManageSimItemHook = ({
  context,
  selectedSims,
  handleModalOpen,
  onActionTaken,
  onSimsModified,
  disabled,
  segmentName,
}) => {
  const onClick = useCallback(() => {
    handleModalOpen({
      modalName: 'SimInventoryBulkSendMessageModal',
      modalProps: { sims: selectedSims, onModalSuccess: onSimsModified },
    });
    onActionTaken();
  }, [onActionTaken, handleModalOpen, onSimsModified, selectedSims]);

  const { simDetails } = useSimDetails(
    context === 'details' && selectedSims ? [...selectedSims.keys()][0] : undefined
  );

  const { networkStatusGroups } = useSimStatuses();

  const show =
    (context === 'inventory' && segmentName !== 'deactivated') ||
    (context === 'details' &&
      (networkStatusGroups?.deactivated?.findIndex(
        (state) => simDetails.networkStatus?.localeCompare(state) === 0
      ) ?? -1) === -1);

  return useMemo<DropdownItemEntry | false>(
    () =>
      show && {
        children: selectedSims?.size === 1 ? 'Send message to SIM...' : 'Send message to SIMs...',
        iconStart: 'Chat',
        disabled,
        onClick,
        id: `sim${context}-messaging-sendsms`,
      },
    [context, disabled, onClick, selectedSims?.size, show]
  );
};

export default useSendMessage;
